module.exports = __webpack_public_path__ + "static/media/nightowl-barview.1b90dbb2.png";